/**
 * Static asset paths for Elite Plans UI.
 * Centralized so renames under `/public` only touch one module, and so CMS
 * never needs to ship absolute paths for these shared chrome assets.
 */
import { cdnBaseUrl } from '../../../env'

export const ELITE_PLANS_RESPONSIVE_ALLOCATION_RIVE = '/rives/elite-plans/responsive_allocation.riv'
export const ELITE_PLANS_IN_REVIEW_RIVE = '/rives/elite-plans/in_review.riv'

/** “Our pricing philosophy” — opened via `openInBrowser` on Elite lock-in banner. */
export const ELITE_PLANS_PRICING_PHILOSOPHY_URL = `${cdnBaseUrl}/html/elite-landing-pages/Pricing.html`

export const ELITE_PLANS_RISK_PROFILE_ICON_BASE = '/images/elite-plans/elite-prime/risk-profiles'

export const ELITE_PLANS_LEARN_ASSET_ALLOCATION_ICON_SRC =
  '/images/elite-plans/elite-prime/learn-carousel/asset-allocation-icon.svg'
export const ELITE_PLANS_LEARN_REALLOCATION_ICON_SRC =
  '/images/elite-plans/elite-prime/learn-carousel/reallocation-icon.svg'

export const ELITE_PLANS_TESTIMONIAL_QUOTE_ICON_SRC = '/images/elite-plans/testimonials/quote.svg'
export const ELITE_PLANS_AVATAR_PLACEHOLDER_SRC = '/images/elite-plans/avatar-placeholder.svg'

export const ELITE_PLANS_COMPARE_CHEVRON_EXPANDED_SRC = '/images/mf-l2/chevron-expanded-icon.svg'
export const ELITE_PLANS_COMPARE_CHEVRON_COLLAPSED_SRC = '/images/mf-l2/chevron-collapsed-icon.svg'
